import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import QRCode from 'qrcode.react';
import { useFirebaseAuth } from '../hooks/useFirebaseAuth';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function Booking() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useFirebaseAuth();
  
  const [bookingDetails, setBookingDetails] = useState({
    name: '',
    email: currentUser?.email || '',
    phone: '',
  });
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [bookingId, setBookingId] = useState(null);

  const handleInputChange = (e) => {
    setBookingDetails({
      ...bookingDetails,
      [e.target.name]: e.target.value
    });
  };

  const handlePayment = async () => {
    try {
      const stripe = await stripePromise;
      // TODO: Implement Stripe payment processing using the id
      const randomBookingId = Math.random().toString(36).substr(2, 9);
      setBookingId(randomBookingId);
      setBookingConfirmed(true);
    } catch (error) {
      console.error('Payment error:', error);
    }
  };

  if (bookingConfirmed) {
    return (
      <Box className="container mx-auto p-4">
        <Paper className="p-6 max-w-md mx-auto">
          <Typography variant="h5" className="mb-4">Booking Confirmed!</Typography>
          <QRCode value={bookingId} className="mx-auto mb-4" />
          <Typography>Booking ID: {bookingId}</Typography>
          <Button 
            variant="contained" 
            color="primary" 
            fullWidth 
            className="mt-4"
            onClick={() => navigate('/')}
          >
            Back to Home
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <Box className="container mx-auto p-4">
      <Paper className="p-6 max-w-md mx-auto">
        <Typography variant="h5" className="mb-4">Complete Your Booking</Typography>
        
        <form className="flex flex-col gap-4">
          <TextField
            label="Name"
            name="name"
            value={bookingDetails.name}
            onChange={handleInputChange}
            required
          />
          <TextField
            label="Email"
            name="email"
            type="email"
            value={bookingDetails.email}
            onChange={handleInputChange}
            required
          />
          <TextField
            label="Phone"
            name="phone"
            value={bookingDetails.phone}
            onChange={handleInputChange}
            required
          />
          
          <Button 
            variant="contained" 
            color="primary"
            onClick={handlePayment}
            disabled={!bookingDetails.name || !bookingDetails.email || !bookingDetails.phone}
          >
            Proceed to Payment
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default Booking; 